enum BiteLogKioskEvent {
  OK = 0,
  Update = 1,
  TurnedOff = 2,
  TurnedOffIndefinitely = 3,
  TurnedOn = 4,
  /** @deprecated */
  ApnSentDeprecated = 11,
  /** @deprecated */
  ApnSendErrorDeprecated = 12,
  PushSent = 16,
  PushSendError = 17,
  StatusMissing = 21,
  StatusRecovered = 22,
  EnabledAda = 31,
  EnableAdaError = 32,
  DisabledAda = 36,
  DisableAdaError = 37,
  MovedMDMGroup = 41,
  MoveMDMGroupError = 42,
  DeviceReboot = 43,
  DeviceRebootError = 44,
  Inactive = 51,
}

export { BiteLogKioskEvent };
